var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tender)?_c('ItemTopActions',{attrs:{"options":{
    id: _vm.tender.tenderId,
    number: _vm.tender.tenderNumber,
    title: _vm.tender.title,
    showParticipantsLink: true,
  }}},[(_vm.tender)?_c('EntitySubscription',{staticClass:"my-auto ml-1",attrs:{"mode":"icon","value":_vm.tender}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }